var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 27"}},[_c('g',{attrs:{"fill":"#D8D8D8","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h20v27H0zM25 0h25v27H25z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }